import { useSelector } from 'react-redux';
import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { getZodiac } from '@packages/shared/core/user/store/selectors';
import { ContextAnimationInformationStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

export type AnimationInformationQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const AnimationInformationQuizStep = ({ id, renderQuizScreen }: AnimationInformationQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, userPreferences } = useQuizStep(id);

  const zodiac = useSelector(getZodiac);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { getGoal, getTitle } = stepData as ContextAnimationInformationStepData;

  const goal = getGoal ? getGoal(userPreferences.goal) : '';
  const title = getTitle(userPreferences.goal);

  const goBack = async () => back();

  const onContinue = async () => next();

  return (
    <>
      {renderQuizScreen({
        onContinue,
        onBack: goBack,
        zodiac,
        goal,
        ...title,
        ...(stepData as ContextAnimationInformationStepData),
      })}
    </>
  );
};

export default AnimationInformationQuizStep;
